/* eslint consistent-return: 0, class-methods-use-this: 0 */
import {
  clone, has, isEmpty, remove,
} from 'lodash';
import CustomCommandTemplates from 'client/api/v2/CustomCommandTemplatesApi';
import GitHubCommandsApi from 'client/api/v2/GitHubCommandsApi';

class CommandTemplatesApi {
  applyFilters(items, filters) {
    if (!filters || !filters.length) return items;

    const appliedFilters = filters.filter(f => (f.value !== ''));

    if (!appliedFilters.length) {
      return items;
    }

    let filteredItems = items.results;

    appliedFilters.forEach((f) => {
      let filterFunction;
      if (f.operator === '$ne' || f.operator === 'ne') {
        filterFunction = item => (item[f.name] !== f.value);
      } else {
        filterFunction = item => (item[f.name] === f.value);
      }

      filteredItems = filteredItems.filter(filterFunction);
    });

    const results = {
      results: filteredItems,
      totalCount: filteredItems.length,
    };

    return results;
  }

  /**
   * Override. Returns a list of CommandTemplates from the API and datastore.
   */
  async fetch(skip, limit, sort, searchTerm, cancelToken, filters = []) {
    // We need to remove the `source` filter because the API does not need or
    // like using it.
    const apiFilters = clone(filters);
    if (!isEmpty(apiFilters)) {
      remove(apiFilters, f => (has(f, 'name') && f.name.toLowerCase() === 'source'));
    }

    // TODO (@richard.shaw): There isn't a API/datastore for command templates
    // right now. We're using GitHub to get the few that we have available to
    // us. Once the Command Templates datastore is made available, we will
    // replace this GitHub implementation with the actual API endpoints.
    let items = await GitHubCommandsApi.getCommands(skip, limit, sort, searchTerm);

    const getOwnedTemplates = async (info) => {
      const { id, name } = info;
      const customItems = await CustomCommandTemplates
        .fetchOwnedTemplates(id, name, skip, limit, sort, searchTerm, apiFilters);

      items.totalCount += customItems.totalCount;
      items.results = customItems.results.concat(items.results);
    };

    if (this.providerInfo) {
      await getOwnedTemplates(this.providerInfo);
    }

    if (this.organizationInfo) {
      await getOwnedTemplates(this.organizationInfo);
    }

    // Handle UI-based filters
    items = this.applyFilters(items, filters);

    return items;
  }

  /**
   * Override.
   * TODO (richard.shaw): Remove when GitHub is no longer used.
   * https://jumpcloud.atlassian.net/browse/MSP-849 is the initial card.
   */
  getSearchField() {
    return {
      field: undefined,
      value: undefined,
    };
  }

  /**
   * @description Set the providerId for the API.
   */
  setProviderId(providerId) {
    this.providerInfo = {
      id: providerId,
      name: 'provider',
    };
  }

  /**
   * @description Set the organizationId for the API.
   */
  setOrganizationId(organizationId) {
    this.organizationInfo = {
      id: organizationId,
      name: 'organization',
    };
  }
}

export default new CommandTemplatesApi();
